import cx from "classnames";
import type { Element } from "React";
import "./IconTrash.scss";
type Props = {
  className?: string;
};

const IconTrash = (props: Props): Element<"svg"> => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    className={cx(props.className, "icon__icon-trash")}
  >
    <title id="icontrash">Trash</title>
    <path d="M16.5 7.5h-9V17A1.5 1.5 0 0 0 9 18.5h6a1.5 1.5 0 0 0 1.5-1.5V7.5zM6 7h12M12 9v8M14 9v8M10 9v8M11 6h2" />
  </svg>
);

export default IconTrash;
